import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';



export default function BotaoEditar (props){
    return <Button 
                {...props}
                icon= "pi pi-wrench"
                severity='primary'
                style={{padding :'4px'}}/>
}
    


 